import { getField, updateField } from 'vuex-map-fields';
import { getAllAnnouncements, getCurrentAnnouncements } from '@/service/GenefoxService';
import Announcement from '@/models/Announcement';

const state = {
  allAnnouncements: [],
  currentAnnouncements: [],
  announcementsSeen: [],
  announcementsNotSeen: []
};

const getters = {
  getField
};

const mutations = {
  updateField
};

const actions = {
  getAllAnnouncements({ commit }) {
    return new Promise((resolve, reject) => {
      getAllAnnouncements()
        .then(response => {
          const announcements = response.data.map(announcement => Announcement.parse(announcement));
          commit('updateField', { path: 'allAnnouncements', value: announcements });
          resolve(announcements);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getCurrentAnnouncements({ commit }) {
    return new Promise((resolve, reject) => {
      getCurrentAnnouncements()
        .then(response => {
          const announcements = response.data.map(announcement => Announcement.parse(announcement));
          commit('updateField', { path: 'currentAnnouncements', value: announcements });
          resolve(announcements);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  initAnnouncementsSeen({ commit }) {
    const announcementsSeen = JSON.parse(localStorage.getItem('announcementsSeen'));
    commit('updateField', { path: 'announcementsSeen', value: announcementsSeen !== null ? announcementsSeen : [] });
  },
  addAnnouncementSeen({ commit }, announcementId) {
    if (!state.announcementsSeen.includes(announcementId)) {
      commit('updateField', { path: 'announcementsSeen', value: [ ...state.announcementsSeen, announcementId ] });
      localStorage.setItem('announcementsSeen', JSON.stringify(state.announcementsSeen));
    }
  },
  initAnnouncementsNotSeen({ commit }) {
    const announcementsSeen = JSON.parse(localStorage.getItem('announcementsSeen'));
    const announcementsNotSeen = state.allAnnouncements.filter(announcement => !announcementsSeen.includes(announcement.id) && !state.currentAnnouncements.map(announcement => announcement.id).includes(announcement.id));
    commit('updateField', { path: 'announcementsNotSeen', value: announcementsNotSeen !== null ? announcementsNotSeen : [] });
  },
  removeAnnouncementNotSeen({ commit }, announcementId) {
    const announcementsNotSeen = state.announcementsNotSeen.filter(announcement => announcement.id !== announcementId);
    commit('updateField', { path: 'announcementsNotSeen', value: announcementsNotSeen });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
